<template>
    <div class="wrapper">
          <router-view></router-view>
        </div>
    </div>
</template>
<script type="text/javascript">
import { mapState } from 'vuex'
import { bus } from './main'

export default {
  data () {
    return {
      context: []
    }
  },
  computed: mapState({
    count: state => state.count
  }),
  methods: {
    showNotificationPopup: function(context) {
      // We emit the event on the event
      bus.$emit('popup', context);
    },
    constructGlanzce: function(context) {
      // We emit the event
      bus.$emit('glance', context);
    }
  },
  components: {
  },
}
</script>
<style lang="scss">
@import "./css/mixins";
@import "./css/reset";
@import "./css/box";
@import "./css/constants";
@import "./css/icons";
//Typefaces
// @include font-face("Hind Light", "./fonts/hind/Hind-Light");
// @include font-face("Hind Medium", "./fonts/hind/Hind-Medium");
// @include font-face("Hind Regular", "./fonts/hind/Hind-Regular");
// @include font-face("Hind SemiBold", "./fonts/hind/Hind-SemiBold");
// @include font-face("Hind Bold", "./fonts/hind/Hind-Bold");
.pulled-left{ color:grey; }
.wrapper { @include box(inherit, inherit, transparent); }
body > .alert { 
  width: 400px !important; min-width: 400px !important; margin-right: 10px;
  z-index: 1000;
  
}
.content {
  position: relative;
  width: 100%; //width of view port - sidebar width
	padding-left: $p24;
	padding-right: $p24;

	background: white;
	overflow: hidden;
  height: 100%;
}
div {
  box-sizing: border-box;
}
html {
  position:relative;
  font-size: $p16;
  overflow: hidden;
  overflow-y: auto;
}
body {
  position: relative;
  background: $gray1;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
  transition: all 0.3s ease;
  //Font
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  text-rendering: optimizeLegibility;
  font-size: 18px;
  line-height: $p16;
}
a {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
  color: inherit;
}
button {
  cursor: pointer;
}
.at-a-glance {
  background: white;
  padding-left: $p16;
  margin-left: -$p16;
  padding-right: $p16;
  margin-right: -$p16;
}

.card {
  background: white;
  box-shadow: $border;
  border-radius: 2px;
  padding: $p24;
  display: flex;
  flex-direction: column;
}

h2 {
  color: $gray6;
  font-family: 'Roboto Slab', serif;
  font-weight: "Bold";
  font-weight: 300;
}

input[type=date], input[type=datetime] { padding: 8px 0;}
input, textarea, select { 
  font-family: 'Roboto', sans-serif; 
  outline: none; 
  border: none;
  color: #90949c;
  font-size: 14px; 
}
textarea:not([disabled]):active,
textarea:not([disabled]):focus,
textarea:not([disabled])
input:not([disabled]):active,
input:not([disabled]):focus,
input:not([disabled]) {
  width:100%;
  height: 30px;
  border-bottom: 1px solid #c3c3c3;
}

input.color,
input:not([disabled]).color:active,
input:not([disabled]).color:focus, { border: none; }
// 
// /* body select.select_box */
select {
  display: block;
  padding-top: 6px;
  padding-bottom: 6px;
  max-width: 100%;
  height: 30px !important;
  border: none !important;
  border-radius: 0px;
  background: transparent;
  border-bottom: 1px solid #c3c3c3 !important;

  font-size: 16px;
  line-height: 16px !important;
  appearance: none; /* this is must */
  -webkit-appearance: none;
  -moz-appearance: none;
}
textarea { 
  width :100%;
  min-width: 100%;
  max-width: 100%;
  height: 25px; 
  max-height: 25px; 
  overflow: auto; 
  border-bottom: 1px solid #c3c3c3 !important; 
}

// custom bootstrp vuejs components
.section-body { display: flex; flex-wrap: wrap; margin-bottom: 15px !important; }
// .input-group-btn {margin-top: -30px !important; vertical-align: top; }
.dropdown-toggle { font-family:'Roboto', sans-serif; height: auto;  }
.dropdown-menu { 
  font-family: 'Roboto', sans-serif;
  min-width: 100%; 
  max-height: 350px !important; 
  overflow: auto; 
  z-index: 5000;
  // color: #
}
.btn-default { color: #333; background-color: #fff; border-color: #ccc; }
.btn.dropdown-toggle, .btn.btn-primary, .btn.btn-danger{
  width: auto;
  display: inline-block;
  padding: 8px 20px;
  border-radius: 3px;
  border: none;
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
}
.btn-primary:hover { background-color: #04bafc; }
.btn-danger:hover { background-color: #ff0000; }
.btn-primary:hover { background-color: #04bafc; }

.modal-dialog { width: 100%; margin: 30px auto 0 auto; }
.modal-body > * {
    line-height: normal;
}
.modal-content { width: 500px; margin: 0 auto; }

.footer{
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  /*bottom: 0px;*/
}

.btn-primary{
  background-color: #04bafc;
}

.report-title .btn{
  border: 1px solid white;
}

.btn-primary.active, .btn-primary:active, .open>.dropdown-toggle.btn-primary {
    color: #fff;
    background-color: #05adea;
    border-color: #204d74;
}

.btn-primary.focus, .btn-primary:focus {
    background-color: #05adea;
  }

.filter-container {
.btn-primary.active, .btn-primary:active, .open>.dropdown-toggle.btn-primary {
    color: #fff;
    background-color: #05adea;
    border-color: #204d74;
}

.btn-primary.focus, .btn-primary:focus {
    background-color: #05adea;
  }
}

h1{
    font-weight: 600;
    font-size: 1.25em;
    margin-bottom: 10px;
    font-family: 'Roboto Slab', serif;
  }

.btn-primary.active.focus, .btn-primary.active:focus, .btn-primary.active:hover, 
.btn-primary:active.focus, .btn-primary:active:focus, .btn-primary:active:hover, 
.open>.dropdown-toggle.btn-primary.focus, .open>.dropdown-toggle.btn-primary:focus, 
.open>.dropdown-toggle.btn-primary:hover{
  background-color: #55bafc;
}

// .container-fluid { height: calc(100% - 30px); }
#card{
  position: relative;
  height: calc(100vh - 289px) !important;
  margin-right: -30px;
  padding: 0 25px 0 0;
  overflow-y: auto; 
  overflow-x: hidden;

  &::-webkit-scrollbar { width: 8px; }
  &::-webkit-scrollbar-track-piece { background-color: transparent; }
  &::-webkit-scrollbar-track {
    // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); 
    background-color: transparent;
    border-radius: 30px;
  }

  &::-webkit-scrollbar-thumb {
    cursor: pointer;
    background: -webkit-linear-gradient(to right, #35B8FB, #56CCF2);
    background: linear-gradient(to right, #35B8FB, #56CCF2);
    outline: 1px solid slategrey;

    border-radius: 30px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 

    &:hover { background: #35B8FB; }
  }
}

.fl-right { float: right; }
.fl-right:after { content: ""; display: table; clear: both; }

.fl-left { float: left; }
.fl-left:after { content: ""; display: table; clear: both; }


@media only screen and (min-width: 1024px) {
  /* For mobile phones: */
  #card{
    height: calc(100vh - 185px);
  }
}

@media only screen and (min-width: 768px) {
  /* For mobile phones: */  
  .btn.dropdown-toggle, .btn.btn-primary.btn-lg{
    margin-bottom: 10px;
    width: auto;
  }  
}

@media only screen and (min-width: 468px) and (max-width: 768px) {
  /* For mobile phones: */
  .dropdown-menu { 
    font-family: 'Roboto', sans-serif;
    max-height: 250px !important;
    overflow: auto; 
    z-index: 5000;
    // color: #
    & li > a {
      white-space: normal;
    }
    table {
      width: 100% !important;
      tbody {
      tr > td {
        button.btn { padding: 10px 14px; }
        }      
      }
    }
    
    .text-center {
      width: 330px !important;
      margin: 0 10px;
      display: inline-block;
      button.btn { width: 80px; font-size: 14px; margin: 5px auto; }
    }
  }
  
  .alert { 
    margin: 0 26px 25px auto;
    z-index: 1000 !important;
    ul.property  {
      li { font-size: 14px; }
    }
  }
  
  element.style {
    position: fixed;
    top: 15px;
    width: 300px;
    transition: all 0.3s ease-in-out 0s;
    right: 15px;
  }
  
  body > .alert {
    width: 320px !important;
    min-width: 320px !important;
    margin-right: 5px;
    z-index: 1000;
    
    .media { font-size: 14px; }
  }
  
  .modal-open { overflow: none; }
  .modal-dialog {
    width: 40% !important;
    margin: 30px auto 0 auto;
    margin-left: 0px;
    
    .modal-content {
      width: 250%;
      margin: 0 auto;
    }
  }

  .container-fluid { width: 100%; }
  .card-section { width: 100%; margin: 0; padding: 0; }
  .btn.dropdown-toggle, .btn.btn-primary.btn-lg{
    width: 100%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
  
  .section-body { 
    width: 100%;
    padding: 0;
    margin: 0;
    
    .col-sm-3 {
      width: 100%;
      display: block;
      padding: 0;
    }
    
    .col-sm-6 {
      width: 100%;
      textarea { width: 100%; }
    }
  }
  
  .more { margin-top: 15px; }
  .contact, .additional {
    width: 100%;
    
    .col-sm-3 { width: 33%; }
    .col-sm-4{ 
      width: 20%; 
      text-align: right;
      
      .col-sm-1 {
        display: inline-block;
        width: 40%;
        margin-top: -5px;
      
        .minus .plus { 
          border: 1px solid #cfcfcf;
          height: 35px;
          width: 33px;
          border-radius: 50%;
          margin-top: 0px;
          margin-left: 0px;
        }
      }     
    }
  }
  
  #card{
    height: 100%;
    width: 95vw;
    position: relative;
    margin: 0 10px 0 0px;
    padding: 0;
  }

  .col-sm-2.col-xs-3.ctrl-col .btn,
  .col-sm-2.col-xs-2.ctrl-col .btn,
  .col-sm-3.col-xs-4.ctrl-col .btn,
  .ctrl-col span{
    font-size: 0.65em !important;
  }
}

@media only screen and (max-width: 468px) {
  /* For mobile phones: */
  .dropdown-menu { 
    font-family: 'Roboto', sans-serif;
    max-height: 250px !important;
    overflow: auto; 
    z-index: 5000;
    // color: #
    & li > a {
      white-space: normal;
    }

    table {
      width: 100% !important;
      tbody {
      tr > td {
        button.btn { padding: 10px 14px; }
        }      
      }
    }
    
    .text-center {
      width: 330px !important;
      margin: 0 10px;
      display: inline-block;
      button.btn { width: 80px; font-size: 14px; margin: 5px auto; }
    }
  }
  
  .alert { 
    margin: 0 26px 25px auto;
    z-index: 1000 !important;
    ul.property  {
      li { font-size: 14px; }
    }
  }
  
  element.style {
      position: fixed;
      top: 15px;
      width: 300px;
      transition: all 0.3s ease-in-out 0s;
      right: 15px;
  }
  
  body > .alert {
      width: 320px !important;
      min-width: 320px !important;
      margin-right: 5px;
      z-index: 1000;
      
      .media { font-size: 14px; }
  }
  
  .modal-open { overflow: none; }
  .modal-dialog {
    width: 40% !important;
    margin: 30px auto 0 auto;
    margin-left: 0px;
    
    .modal-content {
      width: 250%;
      margin: 0 auto;
    }
  }

  .container-fluid { width: 100%; }
  .section-body { 
    width: 100%;
    padding: 0;
    margin: 0;
    
    .col-sm-3 {
      width: 100%;
      display: block;
      padding: 0;
    }
    
    .col-sm-6 {
      width: 100%;
      textarea { width: 100%; }
    }
  }
  .card-section { width: 100%; margin: 0; padding: 0; }
  .btn.dropdown-toggle, .btn.btn-primary.btn-lg {
    width: 100%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
  
  #card {
    height: 100%;
    position: relative;
    width: 95vw;
    margin: 0 -12px 0 10px;
    padding: 0;
  }

  .col-sm-2.col-xs-3.ctrl-col .btn,
  .col-sm-2.col-xs-2.ctrl-col .btn,
  .col-sm-3.col-xs-4.ctrl-col .btn,
  .ctrl-col span{
    font-size: 0.65em !important;
  }

  .more { margin-top: 0px; }
  .contact,  
  .additional {
    width: 100%;
    
    .col-sm-3 { width: 30%; }
    .col-sm-4{ 
      width: 22%; 
      text-align: center;
      
      .col-sm-1 {
        display: inline-block;
        width: 40%;
        margin-top: -5px;
      
        .minus { margin-left: 15px; }
      }     
    }
  }
  
  .contact, .additional {
    width: 100%;
    
    .col-sm-3 { width: 28%; }
    .col-sm-4{ 
      width: 21%; 
      text-align: center;
      
      .col-sm-1 {
        display: inline-block;
        width: 38%;
        margin-top: -5px;
      
        .minus { margin-left: 20px; }
      }     
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue